"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);





 const EXPIRY_OPTIONS = [
  { value: '1d', label: '1 day' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
  { value: '1y', label: '1 year' },
  { value: 'never', label: 'Never' },
]; exports.EXPIRY_OPTIONS = EXPIRY_OPTIONS

 const SCOPE_OPTIONS = [
  { value: 'messages.read', label: 'Read patient messages and conversations' },
  { value: 'messages.write', label: 'Message patients and run campaigns' },
  { value: 'patients.read', label: 'Find and see patients' },
  { value: 'patients.write', label: 'Add, update, and delete patients' },
  { value: 'members.read', label: 'See members and their teams' },
  { value: 'members.write', label: 'Add, change, and remove members' },
  { value: 'teams.write', label: 'Add and remove team members' },
]; exports.SCOPE_OPTIONS = SCOPE_OPTIONS

 const DEFAULT_EXPIRY = '90d'; exports.DEFAULT_EXPIRY = DEFAULT_EXPIRY

 const STATUS_LABELS = {
  active: 'Active',
  expired: 'Expired',
  revoked: 'Revoked',
}; exports.STATUS_LABELS = STATUS_LABELS

const EXPIRING_SOON_DAYS = 14

// Revoked keys are final; active and expired ones can be revoked or given a
// new expiry (which can bring an expired key back).
 const canManageKey = (key) => key.Status !== 'revoked'; exports.canManageKey = canManageKey

// "Expires in 9 days" for an active key that expires within two weeks,
// counted in calendar days; null otherwise.
 const getExpiringSoonLabel = (key, now) => {
  if (key.Status !== 'active' || !key.ExpiresAt) return null
  const today = _moment2.default.call(void 0, now).startOf('day')
  const days = _moment2.default.call(void 0, key.ExpiresAt).startOf('day').diff(today, 'days')
  if (days < 0 || days > EXPIRING_SOON_DAYS) return null
  if (days === 0) return 'Expires today'
  if (days === 1) return 'Expires tomorrow'
  return `Expires in ${days} days`
}; exports.getExpiringSoonLabel = getExpiringSoonLabel

// A new key as it first shows (D-118): its "bt_key_" marker, dots, and the
// last four characters, like other services' key dialogs.
 const maskSecret = (secret) => {
  const marker = _nullishCoalesce(_optionalChain([/^[a-z]+_[a-z]+_/, 'access', _ => _.exec, 'call', _2 => _2(secret), 'optionalAccess', _3 => _3[0]]), () => ( ''))
  const rest = secret.slice(marker.length)
  if (rest.length <= 4) return secret
  return `${marker}${'•'.repeat(12)}${rest.slice(-4)}`
}; exports.maskSecret = maskSecret
